import axios from 'axios/index'

const namespaced = true

const state = {
  appTypes: null
}
const actions = {
  getAppTypes ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/api/private/v3.0/piportals/afb/app-types/'
      })
        .then(response => {
          commit('setAppTypes', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getClient ({ commit }, data) {
    const url = '/api/private/v3.0/piportals/afb/app-types/' + data.type + '/download/' + data.version + '/'
    return new Promise((resolve, reject) => {
      axios.get(url, { responseType: 'blob' })
        .then(response => {
          // console.log(response)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
const mutations = {
  setAppTypes (state, value) {
    state.appTypes = value
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
